import { create } from 'zustand';
import { defaultDateRange, initialFilters, onCallUserPerHourinitialFilters } from '../constants';
import { urlMiddleware } from './middlewares';
import {
  AnalyticsV3ContextActions,
  AnalyticsV3Data,
  DateRange,
  IncidentAnalyticsFilterForm,
  OnCallUsersAnalyticsFilterForm,
  ResponseMetricsType,
} from './types';

interface State {
  isFilterDrawerOpen: boolean;
  tabIndex: number;
  data: AnalyticsV3Data;
  responseMetrics: {
    metricType: ResponseMetricsType;
    tta: number;
    ttr: number;
  };
  filters: IncidentAnalyticsFilterForm;
  onCallUsersFilter: OnCallUsersAnalyticsFilterForm;
  dateRange: DateRange;
}

const initialState: State = {
  isFilterDrawerOpen: false,
  tabIndex: 1,
  data: {
    incidentAnalytics: {
      totalIncidents: 10_000,
      delta: 20,
    },
  },
  responseMetrics: {
    metricType: 'mean',
    tta: 10,
    ttr: 10,
  },
  filters: initialFilters,
  onCallUsersFilter: onCallUserPerHourinitialFilters,
  dateRange: defaultDateRange,
};

interface Actions extends AnalyticsV3ContextActions {
  setData: (data: AnalyticsV3Data) => void;
  setResponseMetricType: (metricType: ResponseMetricsType) => void;
  resetFilters: () => void;
}

export const useAnalyticsV3Context = create<State & Actions>()(
  urlMiddleware((set, get) => ({
    ...initialState,

    // Actions
    setIsFilterDrawerOpen: isOpen => set({ isFilterDrawerOpen: isOpen }),
    setTabIndex: index => set({ tabIndex: index }),
    setFilters: filters => set({ filters }),
    setDateRage: dateRange => set({ dateRange }),
    setOnCallUsersFilter: onCallUsersFilter => set({ onCallUsersFilter }),
    setData: data => set({ data }),
    resetTab: () => set({ tabIndex: 1 }),
    setResponseMetricType: metricType => {
      const { responseMetrics } = get();
      set({ responseMetrics: { ...responseMetrics, metricType } });
    },

    resetFilters: () => {
      set({
        filters: initialFilters,
        onCallUsersFilter: onCallUserPerHourinitialFilters,
        dateRange: defaultDateRange,
      });
    },

    setService: (serviceId, serviceName) =>
      set({
        filters: {
          ...get().filters,
          service: [
            {
              label: serviceName,
              value: serviceId,
            },
          ],
        },
      }),
  })),
);
